export type WeatherSource = 'live' | 'archive' | 'climate' | 'override';

export interface WeatherNow {
  temperatureC: number;
  /** 0..1 */
  humidity: number;
  visibilityM: number;
  precipitationMm: number;
  rainMm: number;
  snowfallCm: number;
  /** 0..1 each */
  cloudLow: number;
  cloudMid: number;
  cloudHigh: number;
  windSpeedMs: number;
  /** Direction the wind comes FROM, degrees from north. */
  windDirDeg: number;
  gustMs: number;
  /** WMO weather code (Open-Meteo subset). */
  code: number;
  source: WeatherSource;
}

export interface WeatherHour extends WeatherNow {
  /** UTC ms at the start of the hour. */
  time: number;
}

export interface DailyTemps {
  /** World-local 'YYYY-MM-DD'. */
  date: string;
  tmaxC: number;
  tminC: number;
}

export interface WeatherHistory {
  hours: WeatherHour[];
  daily: DailyTemps[];
}

export const HOUR_MS = 3_600_000;
export const HISTORY_PAST_HOURS = 168;
export const HISTORY_FUTURE_HOURS = 5;

export function floorHour(ms: number): number {
  return Math.floor(ms / HOUR_MS) * HOUR_MS;
}

/** Hour starts covering [instant - 168 h, instant + 5 h]. */
export function historyHourStarts(instant: number): number[] {
  const first = floorHour(instant) - HISTORY_PAST_HOURS * HOUR_MS;
  const count = HISTORY_PAST_HOURS + HISTORY_FUTURE_HOURS + 1;
  return Array.from({ length: count }, (_, i) => first + i * HOUR_MS);
}
